import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const FooterSection = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { label: 'About Us', href: '/about' },
      { label: 'Services', href: '/services' },
      { label: 'Partner Network', href: '/partner-network' },
      { label: 'Resources', href: '/resources' }
    ],
    support: [
      { label: 'Contact Us', href: '/contact' },
      { label: 'FAQ', href: '/partner-network#faq' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' }
    ],
    social: [
      { label: 'LinkedIn', href: 'https://linkedin.com', icon: 'LinkIcon' },
      { label: 'Twitter', href: 'https://twitter.com', icon: 'LinkIcon' },
      { label: 'Email', href: 'mailto:partners@aichangeleaders.com', icon: 'EnvelopeIcon' }
    ]
  };

  return (
    <footer className="bg-primary text-primary-foreground py-12 lg:py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="relative">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="40" height="40" rx="8" fill="url(#footerGradient)" />
                  <path
                    d="M20 10L12 18H16V28H24V18H28L20 10Z"
                    fill="white"
                    opacity="0.9"
                  />
                  <circle cx="20" cy="22" r="2" fill="white" />
                  <defs>
                    <linearGradient
                      id="footerGradient"
                      x1="0"
                      y1="0"
                      x2="40"
                      y2="40"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#4a6fa5" />
                      <stop offset="1" stopColor="#f39c12" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-bold font-headline leading-tight">
                  AI Change Leaders
                </span>
              </div>
            </div>
            <p className="text-sm text-primary-foreground/80 font-body leading-relaxed">
              Human-centered leadership for successful AI adoption. Transforming organizations through proven methodologies and collaborative expertise.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-bold font-headline mb-4">Company</h3>
            <ul className="space-y-2">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <Link
                    href={link.href}
                    className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-300 font-body"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold font-headline mb-4">Support</h3>
            <ul className="space-y-2">
              {footerLinks.support.map((link, index) => (
                <li key={index}>
                  <Link
                    href={link.href}
                    className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-300 font-body"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold font-headline mb-4">Connect</h3>
            <ul className="space-y-3">
              {footerLinks.social.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-300 font-body"
                  >
                    <Icon name={link.icon as any} size={16} variant="outline" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-primary-foreground/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-primary-foreground/80 font-body">
              &copy; {currentYear} AI Change Leaders. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link
                href="/privacy"
                className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-300 font-body"
              >
                Privacy Policy
              </Link>
              <Link
                href="/terms"
                className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors duration-300 font-body"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;